import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDone24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8.326 17.706-4.04-4.04a.927.927 0 0 1 -.294-.686c0-.564.465-1.005 1.004-1.005.27 0 .49.098.686.294l3.355 3.306 9.281-9.306c.196-.171.466-.269.686-.269.539 0 1.004.44 1.004.98 0 .269-.098.514-.245.71l-10.016 10.016a.98.98 0 0 1 -.71.294.98.98 0 0 1 -.71-.294z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDone24;
